import Gooey, { defineCustomElement, model, calc, dynGet } from '@srhazi/gooey';

document.getElementById(
  'example-custom-elements.tsx'
)!.innerHTML = `<p><my-greeting>World</my-greeting></p>`;

defineCustomElement({
  tagName: 'my-greeting',
  Component: ({ children }) => {
    const state = model({ clicks: 0 });
    return (
      <button on:click={() => (state.clicks += 1)}>
        Hello, {children}
        {calc(() => '!'.repeat(state.clicks))}
      </button>
    );
  },
});
